<div *ngIf="exibirTopo">
  <app-header-tela [titulo]="titulo" [retorno]="'/'"></app-header-tela>

  <!-- <div class="row breadcrumb-passos" [hidden]="passosExibir.length <= 1">
    <kendo-breadcrumb [items]="passosExibir" (itemClick)="onItemClick($event)"    >
      <ng-template kendoBreadCrumbItemTemplate let-passo let-index="index"  >
        <div class="item" role="button" [ngClass]="{'incompleto':index > 0,
                                                    'proximo': passo.proximo && passo.descricao != PassoFeito.descricao}" >
          <i class="{{passo.iconClass}}" *ngIf="passo.iconClass"> </i>

          <span>
            {{ passo.descricao }}
          </span>
        </div>
      </ng-template>
    </kendo-breadcrumb>
  </div> -->

</div>



<div class="fundo div_carrinho {{empresa?.tema}}">
  <!-- Componente de notificação Kendo UI -->
  <kendo-notification-container>
  </kendo-notification-container>

  <div class="d-flex justify-content-center align-items-center flex-column" style="height: 400px;" *ngIf="pedido && pedido.itens.length == 0">
    <div class="p-2">
      <img src="https://promokit.com.br/assets/loja/sem-pedidos.png" width="96px"/>
    </div>
    <div class="p-0">
      <h3 class="text-muted">Sua sacola está vazia</h3>
    </div>
    <div class="p-0">
      <h5 class="text-muted">Adicione Itens</h5>
    </div>
  </div>

  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
        novalidate #frm="ngForm" *ngIf="pedido && pedido.itens.length > 0" >
     <div>
        <div class="mt-2 espaco_topo"></div>

        <div class="checkout-card checkout-order-card">
        <div class="titulo checkout-order-title"  [ngClass]="{'com-mesa': pedido.mesa}">
        <h4 class="d-inline">
          <span *ngIf="pedido.mesa"><b>Mesa {{pedido.mesa.nome}}</b> - </span>
          Seu Pedido <span *ngIf="!pedido.mesa && pedido.codigo"> #{{pedido.codigo}} </span>
        </h4>

        <span *ngIf="pedido.comandaValidada && pedido.mesa" class="badge badge-success ml-2" style="font-size: 12px; vertical-align: middle;">
          <i class="fas fa-check-circle mr-1"></i>Comanda {{pedido.comandaValidada.codigoCartaoCliente}}
        </span>
        <span *ngIf="pedido.tokenCartaoPendente" class="badge badge-info ml-2" style="font-size: 12px; vertical-align: middle;">
          <i class="fas fa-qrcode mr-1"></i>Comanda {{pedido.codigoCartaoPendente}} · mesa pendente
        </span>

        <button *ngIf="exibirTopo || exibirSomenteItens"  [hidden]="pedido.ehDeMultiloja() || true"
                class="btn btn-xs btn-outline-blue  font-13" (click)="abraTelaLoja()">Adicionar mais</button>
      </div>

        <div class="linha nao_mobile"></div>

        <div class="desktop">
        <div *ngFor="let itensDaEmpresa of pedido.itensPorEmpresa">
          <div class="checkout-company-row mt-2" style="overflow: auto;">
            <img src="/images/empresa/{{itensDaEmpresa.empresa.logo}}" class="float-left mr-1" style="width: 36px"/>

            <div>
              <div class="float-left">
                <div class="label_empresa">{{itensDaEmpresa.empresa.nome}}</div>
                <div>{{itensDaEmpresa.itens.length}} produto<span *ngIf="itensDaEmpresa.itens.length > 1"></span></div>
              </div>
              <div class="float-right">
                <button class="btn btn-xs btn-outline-blue" (click)="abraEmpresa(itensDaEmpresa.empresa)">Adicionar Mais</button>
              </div>
            </div>
          </div>
          <div *ngFor="let item of itensDaEmpresa.itens;let i=index;" class="produto pt-2 pb-2 item_produto checkout-order-item">
            <section class="cart-item">
              <div class="mb-1 flex flex-row gap-4">
                <img *ngIf="item.produto.imagens" class="img img-fluid mb-1" style="height: 40px;"
                      [src]="'https://fibo.promokit.com.br/images/empresa/' + item.produto.imagens[0].linkImagem" alt="Imagem">
                <div class="full">
                  <div class="mb-0 flex flex-row justify-between">
                    <h4 class="mt-0 mb-1">
                      {{item.qtde}}{{item.obtenhaUnidade()}}
                      {{item.obtenhaDescricao()}}
                    </h4>
                    <div class="cart-item-price flex flex-column gap-1 text-sm">
                      <span class="preco-antigo" *ngIf="!item.brinde && item.temPrecoAntigo && item.temPrecoAntigo()">
                        {{item.obtenhaTotalPrecoAntigo() | currency: 'BRL'}}
                      </span>
                      <h4 class="preco mt-0 mb-0" *ngIf="!item.brinde">
                        {{item.total | currency: 'BRL'}}

                      </h4>

                      <h4 class="resgate-preco mt-0" *ngIf="item.brinde">
                        -{{item.valorResgatado}} {{item.produto.acumulo}}
                      </h4>

                    </div>
                  </div>

                  <div class="mb-0 flex flex-row justify-between">
                    <div  *ngIf="!pedido.codigo">
                      <h6 *ngIf="!item.produto.ehBrinde" class="d-inline cpointer text-blue"  (click)="editarItem(i, item)">
                        <i class="fe-edit mr-1"></i>
                        <b>Editar</b></h6>
                      <h6 class="d-inline cpointer ml-2 text-danger" (click)="removaItem(item)">
                        <i class="fe-trash mr-1"></i>Remover</h6>
                    </div>


                    <div *ngIf="item.cashback > 0">

                      <span class="badge badge-primary">
                          <i class="fe-star-on " ></i> {{item.cashback | currency: 'BRL'}}
                        </span>
                    </div>

                  </div>
                </div>
              </div>



              <div class="flex flex-row items-center gap-4 opcoes">
               <span *ngIf="item.valoresAdicionais && item.valoresAdicionais.length > 0" class="font-11">
                  <ng-container *ngFor="let last=last;let elemento of item.valoresAdicionais ">
                    {{elemento.qtde}}x {{elemento.nome}}{{elemento.entraUmaVezNoPedido ? ' (entra 1 vez no pedido)' : ''}}{{last ? '' : ', '}}
                  </ng-container>

                </span>

                <span *ngIf="item.observacao" class="font-11 mb-0 ml-1"> ( obs.:<i>"
                  {{item.observacao}}"</i> )</span>
              </div>

            </section>

          </div>
        </div>
      </div>

        <div class="produto item_produto pt-2 pb-0 checkout-card-summary"  >
        <h5 class="checkout-card-title">Resumo do pedido</h5>
        <div class="media" >
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Subtotal</span></h5>
          </div>
          <h5 class="mt-0  " [ngClass]="{'com-desconto':pedido.desconto > 0}">
            {{pedido.obtenhaSubTotal() | currency: 'BRL'}}</h5>
        </div>
        <ng-container *ngFor="let descontoPromocional of pedido.promocoesAplicadas; let i = index;">
          <div class="media mt-0 cupom" *ngIf="descontoPromocional.desconto > 0" [class.mb-0]="i + 1 < pedido.promocoesAplicadas.length">
            <div class="media-body" >
              <i class="fas fa-tags mr-1 fa-lg"></i>

              <h5 class="mt-0 mb-0  float-left ml-2 " style="max-width: 80%">
                <span>Promoção</span>   <br>
                <span class="text-muted"  style="font-size: 12px" ><b>{{descontoPromocional.descricao}}</b></span> <br>

              </h5>
            </div>
            <h5 class="mt-1 text-muted">-{{descontoPromocional.desconto | currency: 'BRL'}} </h5>
          </div>

        </ng-container>

        <div class="media mt-0 cupom" *ngIf="pedido.cupom && !pedido.cupom.aplicarNaTaxaDeEntrega">
          <div class="media-body" >
            <i class="fas fa-ticket-alt mr-1 fa-lg"  ></i>

            <h5 class="mt-0 mb-0  float-left ml-2 ">
              <span>Cupom Desconto</span>   <br>
              <ng-container *ngIf="!pedido.cupom.brindeResgate">
                <span class="text-muted"  ><b>{{pedido.cupom.codigo}}</b></span>
                <span *ngIf="pedido.cupom.restrito" class="texto-cupom-alerta">
                    <br>
                  <i class="fas fa-exclamation-circle  mr-1"></i>
                  <i>Esse cupom é de uso restrito, validaçao sera feita ao finalizar seu pedido</i>
                </span>
                <br>
                <span class="td-inline cpointer   text-danger  " (click)="removaCupom()"  >remover</span>
              </ng-container>


              <p *ngIf="pedido.cupom.erro" class="text-danger  font-12 mt-1">
                <i class="fa-times-circle fa "></i>
                 {{pedido.cupom.erro}} </p>
              <p *ngIf="pedido.cupom.substituidoPorDescontoPagamento" class="cupom-substituido-aviso font-12 mt-1">
                O desconto {{pedido.pagamento.formaDePagamento.descricao}} é maior que o cupom: aplicamos o maior.
              </p>
            </h5>
          </div>
          <h5 class="mt-1  text-muted" [hidden]="pedido.cupom.cashback"
              [class.cupom-substituido-valor]="pedido.cupom.substituidoPorDescontoPagamento">
            <span *ngIf="pedido.desconto > 0">-</span>
             {{pedido.cupom.desconto | currency: 'BRL'}} </h5>
        </div>

        <div class="media total-row total-row-benefit" *ngIf="pedido.descontoFormaDeEntrega">
          <div class="media-body">
            <h5 class="mt-0 mb-0">
              <span>{{pedido.descricaoDescontoFormaDeEntrega}}</span><br>
              <small style="font-size: 10px">Benefício aplicado pela forma de entrega escolhida</small>
            </h5>
          </div>
          <h5 class="mt-0 desconto-premium">
            -{{pedido.descontoFormaDeEntrega | currency: 'BRL'}}
          </h5>
        </div>

        <div class="media total-row" *ngIf="pedido.descontoFormaDePagamento">
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Desconto {{pedido.pagamento.formaDePagamento.descricao}}</span></h5>
          </div>
          <h5 class="mt-0  "  >
            {{0 - pedido.descontoFormaDePagamento | currency: 'BRL'}}</h5>
        </div>

        <div class="media" *ngIf="pedido.entrega && pedido.entrega.taxaDeEntrega >= -1">
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Taxa de entrega</span></h5>
          </div>
          <h5 class="mt-0  " *ngIf="!this.calculandoTaxa && pedido.entrega.taxaDeEntrega !== -1">
            {{pedido.obtenhaValorTaxaEntrega() | currency: 'BRL'}}</h5>
          <h5 class="mt-0 " *ngIf="!this.calculandoTaxa && pedido.entrega.taxaDeEntrega === -1">A Informar</h5>
          <h5 class="mt-0  " *ngIf="this.calculandoTaxa">Recalculando <i class="k-icon k-i-loading mr-1"></i></h5>
        </div>

        <div class="media" *ngIf="pedido.taxaFormaDePagamento">
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Taxa forma de pagamento</span></h5>
          </div>
          <h5 class="mt-0  "  >
            {{pedido.taxaFormaDePagamento | currency: 'BRL'}}</h5>
        </div>

        <div class="media mt-0" *ngIf="pedido.valoresAdicionais && pedido.valoresAdicionais.length > 0">
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Extras do Pedido</span></h5>
            <small class="text-muted">
              <ng-container *ngFor="let last=last;let elemento of pedido.valoresAdicionais ">
                {{elemento.qtde}}x {{elemento.nome}}{{elemento.entraUmaVezNoPedido ? ' (entra 1 vez no pedido)' : ''}}{{last ? '' : ', '}}
              </ng-container>
            </small>
          </div>
          <h5 class="mt-0">{{pedido.obtenhaValorAdicionais() | currency: 'BRL'}}</h5>
        </div>

        <div class="media mt-0 cupom" *ngIf="pedido.cupom && pedido.cupom.aplicarNaTaxaDeEntrega">
          <div class="media-body">
            <i class="fas fa-ticket-alt mr-1 fa-lg"  ></i>

            <h5 class="mt-0 mb-1  float-left ml-3 ">
              <span>Cupom Desconto</span>    <span class="td-inline cpointer ml-2 text-blue ml-1" (click)="removaCupom()">remover</span><br>
              <span class="text-muted"  ><b>{{pedido.cupom.codigo}}</b></span>
              <small *ngIf="!pedido.entrega.endereco" class="font-11"  >
                <br> Cupom de taxa de entrega será aplicado assim que você escolher o endereço de entrega
              </small>
            </h5>
          </div>
          <h5 class="mt-1 text-muted" [hidden]="pedido.cupom.cashback">
            <span *ngIf="pedido.desconto > 0">-</span>
            {{pedido.desconto | currency: 'BRL'}} </h5>

          <p *ngIf="pedido.cupom.erro" class="text-danger  font-12 mt-1">
            <i class="fe-alert-triangle mr-1"></i>
             {{pedido.cupom.erro}} </p>


        </div>

        <div class="media mt-0">
          <div class="media-body">
            <h5 class="mt-0 mb-1"><span>Total</span></h5>
          </div>
          <h4 class="mt-0 preco total"><strong>{{pedido.total | currency: 'BRL'}}</strong></h4>

        </div>

        <div class="media mt-0" *ngIf="pedido.totalResgatado">
          <div class="media-body">
            <h5 class="mt-0 mb-1"><span>Total Resgate</span></h5>
          </div>
          <h4 class="mt-0 resgate-preco"><strong>-{{pedido.totalResgatado}} {{pedido.acumulo}}</strong></h4>

        </div>

        <div class="checkout-step-row checkout-step-row-cupom" *ngIf="!pedido.cupom && (!pedido.estaEmFluxoMesa() || empresa.permitirCupomMesas)">
          <div class="checkout-step-icon">
            <i class="fas fa-ticket-alt"></i>
          </div>
          <div class="checkout-step-label">
            <ng-container *ngIf="aplicarCupom">
              <div style="cursor: pointer" (click)="toggleAplicarCupom()" class="mb-1 div_cupom">
                <label>Adicione um código promocional</label>
              </div>
              <div class="input-group mb-2">
                <input type="text" class="form-control" name="codigoCupom" placeholder="Código do cupom"
                       [(ngModel)]="pedido.codigoCupom" [disabled]="aplicandoCupom"  >
                <div class="input-group-append">
                  <button class="btn  btn-outline-blue" type="button" (click)="apliqueCupom()">Aplicar</button>
                </div>
              </div>
            </ng-container>

            <div *ngIf="cuponsSelecionar.length">
              <div class="cpointer d-flex justify-content-between" (click)="escolherCupons($event)"   >
                <label style="padding-top: 2px"> {{cuponsSelecionar.length - 1}} {{cuponsSelecionar.length - 1 ===  1? 'cupom disponível': 'cupons disponíveis'}} </label>
                <button class="btn btn-sm btn-outline-blue" [disabled]="selecionandoCupom" >Adicionar</button>
              </div>
            </div>

            <div (click)="toggleAplicarCupom()" style="cursor: pointer" *ngIf="!aplicarCupom && !cuponsSelecionar.length" class="mb-2 div_cupom">
              <label>Possui cupom?</label>
            </div>

            <p *ngIf="erroCupom" class="text-danger mt-0"><b>{{erroCupom}}</b></p>
          </div>
          <i class="fe-chevron-right checkout-step-chevron"></i>
        </div>

        <ng-container *ngIf="estaPontuando()">
          <h6 class="clearfix float-right " style="line-height: 20px">
            <i class="fe-star-on   text-blue"></i>
            <ng-container  *ngIf="empresa.integracaoPedidoFidelidade.plano.tipoDeAcumulo!=='Reais'">

              Compre e ganhe  <span class="" *ngIf="pedido?.pontosReceber"><b>{{pedido.pontosReceber}}</b></span>
              no programa  <span class=""><b>{{empresa.integracaoPedidoFidelidade.plano.nome}}</b></span>
            </ng-container>
            <ng-container  *ngIf="empresa.integracaoPedidoFidelidade.plano.tipoDeAcumulo==='Reais'">

              <ng-container  *ngIf="(!pedido.contato || pedido.contato.naoIdentificado) && pedido.pontosReceber > 0">
                Ao optar por não informar nome e telefone você esta
                deixando de acumular <span class=""><b>{{pedido.pontosReceber}}</b></span>  nesse pedido
              </ng-container>

              <ng-container
                *ngIf="!pedido.pontosReceber && pedido.total   && empresa.integracaoPedidoFidelidade.plano.valorMinimoPontuar">
                Compre acima de <b>{{empresa.integracaoPedidoFidelidade.plano.valorMinimoPontuar | currency: "BRL"}} </b>
                e ganhe {{valorPencentual(empresa.integracaoPedidoFidelidade.atividade.cashback)}}% de cashback

                <span *ngIf="empresa.integracaoPedidoFidelidade.plano.vencimento">
              para usar até {{ empresa.integracaoPedidoFidelidade.plano.vencimento | date: 'dd/MM'}}
            </span>

                <span *ngIf="empresa.integracaoPedidoFidelidade.plano.validade">
               para usar nos próximos {{empresa.integracaoPedidoFidelidade.plano.validade}} dias
            </span>
              </ng-container>

              <ng-container *ngIf="pedido.contato && !pedido.contato.naoIdentificado && pedido.pontosReceber">
                Com este pedido, você ganhará <span class=""><b>{{pedido.pontosReceber}}</b></span> de cashback

                <span *ngIf="empresa.integracaoPedidoFidelidade.plano.vencimento">
              para usar até {{ empresa.integracaoPedidoFidelidade.plano.vencimento | date: 'dd/MM'}}
            </span>

                <span *ngIf="empresa.integracaoPedidoFidelidade.plano.validade">
               para usar nos próximos {{empresa.integracaoPedidoFidelidade.plano.validade}} dias
            </span>

              </ng-container>
            </ng-container>
          </h6>
          <div class="clearfix"></div>
        </ng-container>

      </div>
      </div>

      <div class="produto item_produto pt-2 pb-0 checkout-card"  *ngIf="pedido.pagamento && pedido.pagamento.trocoPara > 0">

        <div class="media" >
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Dinheiro</span></h5>
          </div>
          <h5 class="mt-0">{{pedido.pagamento.trocoPara | currency: 'BRL'}}</h5>
        </div>

        <div class="media" *ngIf="pedido.pagamento && pedido.troco">
          <div class="media-body">
            <h5 class="mt-0 mb-1 text-muted"><span>Troco</span></h5>
          </div>
          <h5 class="mt-0 preco ">{{pedido.troco | currency: 'BRL'}}</h5>
        </div>

      </div>

      <div class="linha mt-0 mb-0" *ngIf="pedido.itens.length > 3 && !exibirSomenteItens"></div>

      <div class="produto checkout-card checkout-steps-card" *ngIf="!exibirSomenteItens">
        <ng-container  *ngIf="!desktop">
          <div class="checkout-step-row" *ngIf="pedido.contato?.nome && pedido.contato?.telefone" (click)="abraTelaDadosCliente()">
            <div class="checkout-step-icon">
              <i class="far fa-user"></i>
            </div>
            <div class="checkout-step-label">
              <h5><span class="titulo_escuro">Meus dados</span></h5>
            </div>
            <div class="checkout-step-value">
              <strong>{{pedido.contato.nome}}</strong> <br>
              <label class="text-muted mt-1" *ngIf="pedido.contato.cpf">{{pedido.contato.cpf | cpf}}  / </label>
              <label class="text-muted mt-1" *ngIf="pedido.contato.cnpj">{{pedido.contato.cnpj | cnpj}}  / </label>
              <label class="text-muted mt-1" *ngIf="!pedido.contato.naoIdentificado">{{pedido.contato.telefone | telefone}}</label>

              <p class="text-warning" *ngIf="this.PassoIdentificacao.mensagem">
                <i class="fa fa-exclamation-triangle"></i> pendencia:
                <b>{{this.PassoIdentificacao.mensagem}}</b></p>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>

          <div class="checkout-step-row" *ngIf="(!pedido.contato.nome || !pedido.contato.telefone) && (empresa && empresa.tema !== 'quiosque')" (click)="abraTelaDadosCliente()">
            <div class="checkout-step-icon">
              <i class="far fa-user"></i>
            </div>
            <div class="checkout-step-label">
              <h5><span class="titulo_escuro">Meus dados</span></h5>
            </div>
            <div class="checkout-step-value">
              <button class="btn btn-xs btn-outline-blue" type="button" (click)="abraTelaDadosCliente()"  *ngIf="!pedido.contato.telefone">
                Entrar ou Cadastrar</button>
              <button class="btn btn-xs btn-outline-blue" type="button" (click)="abraTelaDadosCliente()" *ngIf="pedido.contato.telefone">
                Completar cadastro</button>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>

          <div class="checkout-step-row" (click)="abraTelaFormaEntrega()" *ngIf="pedido.entrega.formaDeEntrega">
            <div class="checkout-step-icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="checkout-step-label">
              <h5><span>Entrega</span></h5>
              <small class="text-muted" *ngIf="pedido.dataEntrega">
                Agendado para {{descricaoAgendamento()}}
              </small>
              <small class="text-muted" *ngIf="empresa && !pedido.dataEntrega && pedido.permiteAgendamento(pedido.entrega.formaDeEntrega, empresa.formasDeEntrega)">
                Agendar pedido
              </small>
              <small class="text-muted" *ngIf="pedido.entrega && pedido.entrega.ehDelivery() && pedido.entrega.endereco">
                {{pedido.entrega.endereco.obtenhaEnderecoCompleto()}}
              </small>
            </div>
            <div class="checkout-step-value">
              <strong>{{pedido.entrega.formaDeEntrega}}</strong>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>

          <div class="checkout-step-row" *ngIf="pedido.informouFormaDePagamento() && !pedido.maisDeUmaFormaPagamento() && pedido.pagamento" (click)="abraTelaFormaDePagamento()">
            <div class="checkout-step-icon">
              <i class="far fa-credit-card"></i>
            </div>
            <div class="checkout-step-label">
              <h5><span>Pagamento</span></h5>
            </div>
            <div class="checkout-step-value">
              <strong>{{pedido.obtenhaDescricaoPagamento()}}</strong>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>

          <div class="checkout-step-row checkout-step-row-multiple" *ngIf="pedido.informouFormaDePagamento() && pedido.maisDeUmaFormaPagamento() && pedido.pagamento" (click)="abraTelaFormaDePagamento()">
            <div class="checkout-step-icon">
              <i class="far fa-credit-card"></i>
            </div>
            <div class="checkout-step-label">
              <h5><span>Pagamentos</span></h5>
            </div>
            <div class="checkout-step-value">

              <h5 class="mt-0 text-right"  *ngIf="pedido.cashback" >
                <strong>Cashback:
                  <span class="preco">  {{obtenhaSaldo(pedido.cashback.valor)}} </span>
                </strong>
              </h5>

              <h5 class="mt-0 text-right"  *ngIf="pedido.resgate" >
                <strong>Pontos Consumidos:
                  <span class="resgate-preco">  -{{pedido.resgate.valor}} {{pedido.acumulo}} </span>
                </strong>
              </h5>


              <h5 class="mt-0 text-right" *ngIf="pedido.pagamento?.formaDePagamento">
                <strong>{{  pedido.pagamento.formaDePagamento.descricao}}:
                  <span class="preco">  {{ pedido.obtenhaValorAhPagar() | currency: "BRL"}}</span>
                </strong>
              </h5>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>

          <div class="checkout-step-row" *ngIf="!pedido.informouFormaDePagamento() && pedido.informouFormaDeEntrega()" (click)="abraTelaFormaDePagamento()">
            <div class="checkout-step-icon">
              <i class="far fa-credit-card"></i>
            </div>
            <div class="checkout-step-label">
              <h5>Pagamento</h5>
            </div>
            <div class="checkout-step-value">
              <button class="btn btn-xs btn-outline-blue" type="button" (click)="abraTelaFormaDePagamento()">
                Definir</button>
            </div>
            <i class="fe-chevron-right checkout-step-chevron"></i>
          </div>
        </ng-container>
      </div>



      <div style="height: 40px" class="mobile"></div>

      <!-- Adicionando a mensagem de erro fora do footer para que seja sempre visível -->
      <p class="alert alert-danger mt-2" role="alert" *ngIf="msgErro">
        <i class="fa fa-times mr-2"></i> {{msgErro}}
      </p>

      <footer class="footer" [hidden]="exibirSomenteItens || !this.exibirBotoes">
        <p class="alert alert-success" role="alert" *ngIf="msg">
          <i class="mdi mdi-check-all mr-2"></i>  {{msg}}
        </p>

        <ng-container *ngIf="empresa && !pedido.entrega.foiPreenchida() && !pedido.estaEmFluxoMesa()">
          <div class="alert alert-danger  mt-2" [hidden]="msgErro"  *ngIf="pedido.ultrapassouValorMaximo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega)">
            <i class="fa fa-times mr-2"></i>
            As entregas são feitas somente para valores abaixo de
              {{pedido.obtenhaValorMaximoParaEntrega(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega) | currency: "BRL"}}
          </div>

          <div class="alert alert-danger mt-2" [hidden]="msgErro"  *ngIf="!pedido.temValorMinimo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega)">
            <i class="fa fa-times mr-2"></i>
            As entregas são feitas somente para valores acima de
            {{pedido.obtenhaValorMinimoParaEntrega(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega) | currency: "BRL"}}
          </div>

        </ng-container>

        <div class="checkout-footer-bar">
            <div class="checkout-footer-total" *ngIf="!pedido.codigo">
              <span>Total do pedido</span>
              <strong>{{pedido.total | currency: 'BRL'}}</strong>
            </div>
            <div class="checkout-footer-actions" *ngIf="!pedido.codigo">

              <ng-container *ngIf="empresa && empresa.tema === 'quiosque'">
                <button class="btn btn-primary btn-block waves-effect width-lg btn-lg"
                        type="button" (click)="finalizarPedidoTotem()" *ngIf="!estahCompleto">
                  Finalizar Pedido <i class="fe-chevron-right  "></i>
                </button>
              </ng-container>

              <ng-container *ngIf="!desktop && empresa && empresa.tema !== 'quiosque'">
                <button class="btn btn-blue btn-block waves-effect btn-lg-block"
                        type="button" (click)="proximoPasso()" *ngIf="!estahCompleto">
                  Proximo <i class="fe-chevron-right  "></i>
                </button>

                <button class="btn btn-primary btn-block waves-effect width-lg"
                        type="button"   (click)="fazerPedido(false)" *ngIf="estahCompleto"
                        [disabled]="eviandoPedido || calculandoTaxa" >
                  <i class="k-icon k-i-loading mr-1" *ngIf="eviandoPedido"></i>
                  Fazer Pedido
                </button>
              </ng-container>


              <button class="btn-finalizar-pedido btn btn-blue btn-block waves-effect btn-lg-block"
                      type="button" (click)="vaParaTelaFinalizarDesktop()" *ngIf="desktop">
                 Finalizar Pedido
              </button>



            </div>

            <div class="checkout-footer-actions checkout-footer-actions-full" *ngIf="pedido.codigo">
              <a class="btn btn-blue btn-block waves-effect width-lg mb-1" *ngIf="pedido.gerarLinkPagamento"
                 [href]="dominiosService.obtenhaUrlAcompanharPedido(pedido)"  >
                Ver detalhes
              </a>
              <!-- Removido pois estamos abrindo automaticamente
              <a class="btn btn-success btn-block waves-effect width-lg mb-1"  [href]="urlWhatsapp" target="_blank"  *ngIf="!pedido.gerarLinkPagamento" >
                <i class="fab fa-whatsapp fa-lg mr-1" ></i>
                Enviar para Whatsapp {{empresa?.nome}}
              </a>
              -->
            </div>
        </div>

        <app-powered-by [tema]="empresa?.tema"></app-powered-by>
      </footer>
    </div>
  </form>

</div>

<div id="alertaGerandoPagamento" class="modal fade" tabindex="-1" role="dialog"   aria-modal="true" data-backdrop="static">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-body p-4">
        <div class="text-center">
          <h5 class="mt-2">
            <i class="k-icon k-i-loading mr-1"></i>
            Aguarde que você será redirecionado para tela de  pagamento.</h5>

        </div>
      </div>
    </div>
  </div>
</div>

<kendo-dialog title="Selecionar Cupom" (close)="fecheModalCupom()"
              *ngIf="exibirModalEscolherCupons">
  <div id="modalEscolherCupons" *ngIf="this.cuponsSelecionar.length" tabindex="-1">
    <div class="input-group mb-3">
      <input type="text" class="form-control" name="codigoCupom" placeholder="Código do cupom"
             [(ngModel)]="pedido.codigoCupom" [disabled]="aplicandoCupom">
      <div class="input-group-append">
        <button class="btn btn-outline-blue" type="button" (click)="apliqueCupomTelaSelecionar()">Aplicar</button>
      </div>
    </div>
    <form style="padding-bottom: 0px; max-width: 600px">
      <div *ngFor="let cupom of cuponsSelecionar" class="card-cupom mb-3" [ngClass]="{'cupom-selecionado': cupomSelecionado === cupom}">
        <div class="cupom-row">
          <span class="cupom-icone"><i class="fas fa-ticket-alt"></i></span>
          <div class="cupom-nome-badges">
            <span class="cupom-nome">{{cupom.nome}}</span>
            <ng-container *ngIf="cupom.restrito">
              <span class="cupom-badge restrito">USO RESTRITO</span>
            </ng-container>
            <ng-container *ngIf="cupom.percentual">
              <span class="cupom-badge off">{{cupom.percentual}}% OFF</span>
            </ng-container>
            <ng-container *ngIf="cupom.valor">
              <span class="cupom-badge off">-{{cupom.valor | currency:'BRL'}}</span>
            </ng-container>
            <ng-container *ngIf="cupom.primeiraCompra">
              <span class="cupom-badge novo">Novos clientes</span>
            </ng-container>
          </div>
          <span class="flex-spacer"></span>
          <input [(ngModel)]="cupomSelecionado"
                 [value]="cupom"
                 name="cupomSelecionado"
                 type="radio"
                 kendoRadioButton
                 (ngModelChange)="escolheuCupom(cupom)"
                 class="float-right"/>
        </div>
        <div class="cupom-descricao" *ngIf="cupom.fraseDescritiva">{{cupom.fraseDescritiva}}</div>
        <div class="cupom-alerta" *ngIf="cupom.restrito">
          <i class="fa fa-exclamation-triangle"></i>
          <span><b>Atenção:</b> Esse cupom é de uso restrito e a validação será feita ao finalizar seu pedido</span>
        </div>
        <div class="cupom-link mt-2">
          <a href="#" (click)="verRegras(cupom, $event)" *ngIf="cupom.codigo && !cupom.verRegras">Ver regras completas</a>
          <a href="#" (click)="verRegras(cupom, $event)" *ngIf="cupom.codigo && cupom.verRegras">Esconder regras</a>
          <span class="float-right text-muted" *ngIf="cupom.validade">Validade: {{cupom.validade | date: 'dd/MM/yyyy'}}</span>
        </div>
        <div *ngIf="cupom.verRegras" class="cupom-regras">
          <span class="text-muted" *ngIf="cupom.restrito">- De uso restrito por alguns clientes<br></span>
          <span class="text-muted" *ngIf="cupom.valorMinimo">- Válido para pedidos de no mínimo {{cupom.valorMinimo | currency: 'BRL'}}<br></span>
          <span class="text-muted" *ngIf="cupom.delivery">- Válido apenas para pedido delivery<br></span>
          <span class="text-muted" *ngIf="cupom.retirada">- Válido apenas para pedido retirado pessoalmente<br></span>
          <span class="text-muted" *ngIf="cupom.comerNoLocal">- Válido apenas para pedido consumido na loja<br></span>
          <span class="text-muted" *ngIf="cupom.qtdeMaxima && cupom.qtdeMaxima == 1">- No máximo um uso por cliente<br></span>
          <span class="text-muted" *ngIf="cupom.qtdeMaxima && cupom.qtdeMaxima > 1">- No máximo {{cupom.qtdeMaxima}} usos por cliente<br></span>
          <span class="text-muted" *ngIf="cupom.percentualMaximoDescontoProduto">- Não cumulativo com outras promoções<br></span>
          <span class="text-muted" *ngIf="cupom.quantidade && cupom.validade">- Válido até {{cupom.validade | date: 'dd/MM/yyyy'}} ou até atingir a quantidade de cupons disponíveis<br></span>
          <span class="text-muted" *ngIf="!cupom.quantidade && cupom.validade">- Válido até {{cupom.validade | date: 'dd/MM/yyyy'}}<br></span>
          <span class="text-muted" *ngIf="cupom.quantidade && !cupom.validade">- Válido até atingir a quantidade de cupons disponíveis<br></span>
          <span class="text-muted" *ngIf="!cupom.valorMinimo">- Válido para pedido de qualquer valor<br></span>
          <span class="text-muted" *ngIf="cupom.categorias?.length">- É necessário um produto da(s) categoria(s) <strong>{{getCategoriasNomes(cupom)}}</strong> no carrinho<br></span>
          <span class="text-muted" *ngIf="cupom.produtosTemplateTamanho?.length">- É necessário um produto do(s) tamanho(s) <strong>{{getTamanhosNomes(cupom)}}</strong> no carrinho<br></span>
          <span class="text-muted" *ngIf="cupom.produtos && cupom.produtos.length">- É necessário um produto(s) <strong>{{getNomesProdutos(cupom)}}</strong> no carrinho<br></span>
        </div>
      </div>
    </form>
  </div>
</kendo-dialog>
